import React from "react";
import { getCookie } from "../../helpers/utils";
import Loader from "../Loader";
import { UNAUTHRIZEDPAGE } from "../../constants";
import { LOGINPAGE } from "../../constants";

export default function App(props) {
  const { history } = props;
  const redirectToUNAuthrizePage = () => {
    window.open(UNAUTHRIZEDPAGE, "_self", "norefferer");
  };
  const redirectToLoginPage = () => {
    window.open(LOGINPAGE, "_self", "norefferer");
  };
  return (
    <React.Fragment>
      {getCookie("_e_p_u")
        ? history.push("/entityportal")
        : redirectToLoginPage()}
      <Loader globalWrap={true} />
    </React.Fragment>
  );
}
